import {Box, Button, Grid} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import useAccountId from '../../hooks/useAccountId';
import {themeColors} from '../../theme/Theme';
import {Panel} from '../../components/Panel/Panel';
import {GoalsGrid} from './GoalsGrid/GoalsGrid';
import Loading from '../../components/Loading/Loading';
import {useReviewContext} from '../../contexts/ReviewContext';

export const Goals: React.FC<{readOnly: boolean}> = ({readOnly}) => {
  const {accountId} = useAccountId();
  const navigate = useNavigate();
  const {isFullySubmitted} = useReviewContext();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Panel
          title="Goals"
          style={{
            flexGrow: 1,
          }}
          color={themeColors.coral}
        >
          {readOnly ? null : (
            <Box mb={2} mt={1}>
              <Button
                variant="contained"
                color="primary"
                disabled={isFullySubmitted}
                onClick={() => navigate({pathname: '../goals-builder'})}
              >
                New goal
              </Button>
            </Box>
          )}

          {accountId ? (
            <GoalsGrid readOnly={readOnly} accountId={accountId} />
          ) : (
            <Loading />
          )}
        </Panel>
      </Grid>
    </Grid>
  );
};

export default Goals;
